var exports = {
  "z5": "DirectMessageList.module__dmListContainer___VFpMR0",
  "DS": "DirectMessageList.module__dmListHeader___VFpMR0",
  "vW": "DirectMessageList.module__dmListHeaderButton___VFpMR0",
  "sf": "DirectMessageList.module__dmListHeaderText___VFpMR0",
  "LF": "DirectMessageList.module__dmListHeaderShortcut___VFpMR0",
  "AA": "DirectMessageList.module__mobileContainer___VFpMR0",
  "Od": "DirectMessageList.module__mobileHeader___VFpMR0",
  "yG": "DirectMessageList.module__mobileHeaderTitle___VFpMR0",
  "Fy": "DirectMessageList.module__mobileHeaderActions___VFpMR0",
  "Y0": "DirectMessageList.module__mobileHeaderButton___VFpMR0",
  "OB": "DirectMessageList.module__mobileAddFriendButton___VFpMR0",
  "FG": "DirectMessageList.module__mobileAddFriendBadge___VFpMR0",
  "_D": "DirectMessageList.module__mobileScrollerContent___VFpMR0",
  "rj": "DirectMessageList.module__desktopScroller___VFpMR0",
  "bR": "DirectMessageList.module__mobileScroller___VFpMR0",
  "cB": "DirectMessageList.module__mobileFab___VFpMR0",
  "gT": "DirectMessageList.module__scrollerContent___VFpMR0",
  "e6": "DirectMessageList.module__desktopBottomSpacer___VFpMR0",
  "KW": "DirectMessageList.module__clickableItem___VFpMR0",
  "ZE": "DirectMessageList.module__clickableItemIcon___VFpMR0",
  "xC": "DirectMessageList.module__clickableItemSelected___VFpMR0" + " " + "DirectMessageList.module__clickableItem___VFpMR0",
  "Wo": "DirectMessageList.module__clickableItemInner___VFpMR0",
  "Je": "DirectMessageList.module__clickableItemContent___VFpMR0",
  "AO": "DirectMessageList.module__sendIcon___VFpMR0",
  "hV": "DirectMessageList.module__clickableItemText___VFpMR0",
  "Ax": "DirectMessageList.module__dmSectionSeparator___VFpMR0",
  "MN": "DirectMessageList.module__dmSectionHeader___VFpMR0",
  "Pc": "DirectMessageList.module__dmSectionHeaderText___VFpMR0",
  "il": "DirectMessageList.module__dmSectionHeaderLabel___VFpMR0",
  "yt": "DirectMessageList.module__dmCreateButton___VFpMR0",
  "Qv": "DirectMessageList.module__dmCreateButtonTooltipTarget___VFpMR0",
  "$z": "DirectMessageList.module__dmChannelList___VFpMR0",
  "hZ": "DirectMessageList.module__dmItemMobile___VFpMR0",
  "so": "DirectMessageList.module__dmItemMobileSelected___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "k1": "DirectMessageList.module__dmItemMobileUnread___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "AM": "DirectMessageList.module__dmItemMobileMuted___VFpMR0",
  "Vw": "DirectMessageList.module__dmItem___VFpMR0",
  "Mg": "DirectMessageList.module__dmItemUnread___VFpMR0" + " " + "DirectMessageList.module__dmItem___VFpMR0",
  "Go": "DirectMessageList.module__dmItemMuted___VFpMR0",
  "OV": "DirectMessageList.module__dmItemUnreadIndicatorContainer___VFpMR0",
  "Md": "DirectMessageList.module__dmItemUnreadIndicatorContainerMobile___VFpMR0" + " " + "DirectMessageList.module__dmItemUnreadIndicatorContainer___VFpMR0",
  "wE": "DirectMessageList.module__dmItemUnreadIndicatorContainerDesktop___VFpMR0" + " " + "DirectMessageList.module__dmItemUnreadIndicatorContainer___VFpMR0",
  "tD": "DirectMessageList.module__dmItemUnreadIndicator___VFpMR0",
  "A0": "DirectMessageList.module__dmItemContent___VFpMR0",
  "XW": "DirectMessageList.module__dmItemAvatarWrapper___VFpMR0",
  "F6": "DirectMessageList.module__dmItemInfo___VFpMR0",
  "wu": "DirectMessageList.module__dmItemName___VFpMR0",
  "NA": "DirectMessageList.module__dmItemNameText___VFpMR0",
  "IC": "DirectMessageList.module__dmItemUserTag___VFpMR0",
  "Xl": "DirectMessageList.module__dmItemPinIcon___VFpMR0",
  "qj": "DirectMessageList.module__dmItemSubtext___VFpMR0",
  "EL": "DirectMessageList.module__dmItemCustomStatus___VFpMR0" + " " + "DirectMessageList.module__dmItemSubtext___VFpMR0",
  "Y9": "DirectMessageList.module__dmItemSelected___VFpMR0" + " " + "DirectMessageList.module__dmItem___VFpMR0",
  "ZQ": "DirectMessageList.module__dmItemMembersSubtext___VFpMR0" + " " + "DirectMessageList.module__dmItemSubtext___VFpMR0",
  "Qm": "DirectMessageList.module__dmItemSubtextItalic___VFpMR0",
  "s4": "DirectMessageList.module__dmItemPreviewMarkdown___VFpMR0",
  "Rt": "DirectMessageList.module__dmItemTimestamp___VFpMR0",
  "Xk": "DirectMessageList.module__dmItemCloseButton___VFpMR0",
  "S5": "DirectMessageList.module__mobileSpecialButton___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "tN": "DirectMessageList.module__mobileSpecialButtonSelected___VFpMR0" + " " + "DirectMessageList.module__dmItemMobileSelected___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "Ml": "DirectMessageList.module__mobilePersonalNotesButton___VFpMR0" + " " + "DirectMessageList.module__mobileSpecialButton___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "zh": "DirectMessageList.module__mobilePersonalNotesButtonSelected___VFpMR0" + " " + "DirectMessageList.module__mobileSpecialButtonSelected___VFpMR0" + " " + "DirectMessageList.module__dmItemMobileSelected___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "iu": "DirectMessageList.module__mobilePlutoniumButton___VFpMR0" + " " + "DirectMessageList.module__mobileSpecialButton___VFpMR0" + " " + "DirectMessageList.module__dmItemMobile___VFpMR0",
  "ju": "DirectMessageList.module__dmItemMobilePressed___VFpMR0",
  "lY": "DirectMessageList.module__contextMenuActive___VFpMR0",
  "dJ": "DirectMessageList.module__mobileSpecialButtonContent___VFpMR0",
  "H8": "DirectMessageList.module__mobileSpecialButtonIcon___VFpMR0",
  "Rg": "DirectMessageList.module__mobileSpecialButtonText___VFpMR0",
  "E5": "DirectMessageList.module__mobileSpecialButtonLabel___VFpMR0",
  "yY": "DirectMessageList.module__iconSize5___VFpMR0",
  "Ff": "DirectMessageList.module__iconSize4___VFpMR0",
};

module.exports = exports;
